export enum InformationTypeEnum {
  DATA,
  DOCUMENT,
  REVIEW
}
